export default "__VITE_ASSET__12ea0214__"